import { j as o } from "../../../node_modules/react/jsx-runtime.js";
import { memo as et, useState as A, useRef as ot, useCallback as H, useEffect as w } from "react";
import { useDropzone as rt } from "../../../node_modules/react-dropzone/dist/es/index.js";
import { FieldLabel as nt } from "../TextField/components/FieldLabel/FieldLabel.js";
import st from "./components/CompactFileUpload.js";
import at from "./components/FileUploadInput.js";
import I from "../Spacer/Spacer.js";
import ct from "../TextField/components/FieldHelperText/FieldHelperText.js";
import pt from "./FileInfoBox/FileInfoBox.js";
const O = () => {
  const m = Date.now().toString(36), x = Math.random().toString(36).slice(2, 9);
  return `${m}-${x}`;
}, dt = ({
  label: m,
  iconTooltip: x,
  optionalLabel: k,
  required: C,
  disabled: R,
  multiple: l = !1,
  descriptionMessage: L,
  maxSelectedFiles: a = 4,
  minSizeKB: y,
  maxSizeKB: D,
  initFiles: c,
  testId: E,
  onLoad: h,
  handleDownload: T,
  withPreview: M,
  withRemoveIcon: N = !0,
  handleReload: B,
  compact: Y = !0,
  onRemove: U,
  onError: $,
  errorMessage: q,
  autoComplete: G = "off",
  ...J
}) => {
  const [s, i] = A([]), [K, Q] = A(0), g = ot([]), V = D && D * 1024, W = y && y * 1024, X = document.documentElement.lang == "en" ? `You can upload up to ${a} files. Remove ${s.length - a} files to proceed` : `يمكنك رفع ${a} ملفات بحد أقصى. يرجى حذف عدد ملف ${s.length - a} ملفات للمتابعة.`, _ = (e) => {
    typeof URL < "u" && typeof URL.revokeObjectURL == "function" && URL.revokeObjectURL(e);
  }, Z = H(
    (e) => {
      i((p) => p.filter((f) => f.id !== (e == null ? void 0 : e.id))), e.preview && (_(e.preview), g.current = g.current.filter((p) => p !== e.preview));
    },
    [s.length]
  ), S = H(
    (e, p) => {
      const f = e.map((t) => {
        const r = URL.createObjectURL(t);
        return g.current.push(r), {
          id: O(),
          name: t.name,
          type: t.type,
          size: `${(t.size / 1024).toFixed()} KB`,
          file: void 0,
          preview: r,
          origin_file: t,
          status: "loading"
        };
      });
      i((t) => [...t, ...f]), e.forEach((t) => {
        const r = new FileReader();
        r.onprogress = (n) => {
          if (n.lengthComputable) {
            const d = Math.round(n.loaded / n.total * 100);
            Q(d);
          }
        }, r.onload = (n) => {
          i((d) => {
            var P;
            const v = {
              ...d.find((j) => j.origin_file === t),
              status: "success",
              //@ts-expect-error // EventTarget type missing result
              file: (P = n.currentTarget) == null ? void 0 : P.result
            }, u = l ? d.map((j) => j.origin_file === t ? v : j) : [v];
            return h == null || h(u), u;
          });
        }, r.onerror = () => {
          i((n) => {
            const d = {
              ...n.find((u) => u.origin_file === t),
              status: "rejected"
            };
            return l ? n.map((u) => u.origin_file === t ? d : u) : [d];
          });
        }, r.readAsDataURL(t);
      }), p.forEach((t) => {
        const r = URL.createObjectURL(t.file);
        g.current.push(r), i((n) => [
          ...n,
          {
            id: O(),
            name: t.file.name,
            type: t.file.type,
            size: `${(t.file.size / 1024).toFixed()} KB`,
            file: void 0,
            preview: r,
            origin_file: t.file,
            status: "rejected"
          }
        ]);
      });
    },
    [l, h]
  ), { getRootProps: F, getInputProps: tt, isDragActive: z, fileRejections: b } = rt({
    ...J,
    onDrop: S,
    multiple: l,
    minSize: W,
    maxSize: V,
    useFsAccessApi: !1
  });
  return w(() => {
    b.length && ($ == null || $(b));
  }, [b.length]), w(() => {
    c != null && c.length && i(c);
  }, [c == null ? void 0 : c.length]), w(() => () => {
    g.current.forEach((e) => {
      _(e);
    });
  }, []), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    m && /* @__PURE__ */ o.jsx("div", { className: "pb-100", children: /* @__PURE__ */ o.jsx(
      nt,
      {
        label: m,
        optionalLabel: k,
        required: C,
        tooltipText: x
      }
    ) }),
    /* @__PURE__ */ o.jsxs("div", { ...F(), children: [
      /* @__PURE__ */ o.jsx(
        "input",
        {
          "data-testid": E,
          ...tt(),
          disabled: R || s.length > a,
          autoComplete: G
        }
      ),
      /* @__PURE__ */ o.jsx(I, { height: "4px" }),
      Y ? /* @__PURE__ */ o.jsx(
        st,
        {
          isDragActive: z,
          disabled: R,
          ...s.length <= a && {
            descriptionMessage: L
          }
        }
      ) : /* @__PURE__ */ o.jsx(
        at,
        {
          isDragActive: z,
          disabled: R,
          descriptionMessage: L
        }
      )
    ] }),
    s.length > a && /* @__PURE__ */ o.jsx("div", { className: "mt-100 mb-100", children: /* @__PURE__ */ o.jsx(
      ct,
      {
        label: `${X}`,
        icon: "alert-circle-filled",
        status: "destructive"
      }
    ) }),
    s == null ? void 0 : s.map((e, p) => /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        pt,
        {
          errorMessage: q,
          file: e,
          onHandleRemove: (f) => {
            U == null || U(f, p), Z(f);
          },
          loadingPercentage: K,
          onHandleDownload: T,
          withPreview: M,
          withRemoveIcon: N,
          onHandleReload: B
        }
      ),
      /* @__PURE__ */ o.jsx(I, { height: "8px" })
    ] }))
  ] });
}, Rt = et(dt);
export {
  Rt as default
};
//# sourceMappingURL=FileUpload.js.map
